import { apiClient } from './client'
import endpoints from './endpoints'
import { unwrapVoid } from './normalize'

// The handler's job is res.cookie(...) and its body is message-only, so the browser
// needs withCredentials to accept the cross-origin Set-Cookie.
export const setAuthCookie = async (): Promise<void> => {
  const response = await apiClient.post(endpoints.v2.setAuthCookie, {}, { withCredentials: true })
  return unwrapVoid(response)
}
